import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (

<div className="flex flex-col min-h-screen bg-neutral-100 dark:bg-neutral-700 text-gray-900 dark:text-white transition-all duration-300">
<Navbar />
      <main className="flex-1 relative">
        {/* Background pattern overlay - subtle */}
        <div className="absolute inset-0 opacity-5 dark:opacity-10">
          <div 
            className="w-full h-full"
            style={{
              backgroundImage: `radial-gradient(circle at 1px 1px, rgba(2,89,81,0.15) 1px, transparent 0)`,
              backgroundSize: '20px 20px'
            }}
          />
        </div>
        
        {/* Main content */}
        <div className="relative z-10">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;